// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"378704ca","48":"0499b0a8","150":"4293ecf1","382":"656a3eac","453":"51a16142","637":"9089a617","659":"6f29fc2e","750":"3e52e6fc"}[chunkId] + ".chunk.js";
};